.tag {
  border-radius: var(--sizes-xs);
  padding: 2px var(--sizes-xs);
  display: inline-flex;
  min-width: var(--sizes-3);
  min-height: var(--sizes-5);

  // applies color and font-size for direct text children
  color: var(--custom-text-color, var(--text-body-color));
  font-size: var(--text-body-font-size);

  // ensure Text components (spans) inherit the color
  span {
    color: inherit;
  }

  svg {
    width: var(--sizes-5);
    height: var(--sizes-5);
  }

  &.compact {
    font-size: var(--text-body-small-font-size);

    span {
      font-size: var(--text-body-small-font-size);
    }

    svg {
      width: var(--sizes-base);
      height: var(--sizes-base);
    }
  }
}
